import { utc } from "PFCore/helpers/date";
import { useDateFormatter } from "PFCore/hooks";
import { useCallback } from "react";

export const useWeekRangeFormatter = () => {
  const { formatDay, formatDayMonth, formatDateWithMonthNames } = useDateFormatter();

  return useCallback(
    (startDate: string, endDate: string) => {
      const start = utc(startDate);
      const end = utc(endDate);
      const sameYear = start.year() === end.year();
      const sameMonth = sameYear && start.month() === end.month();

      const startFormatted = sameMonth
        ? formatDay(startDate)
        : sameYear
          ? formatDayMonth(startDate)
          : formatDateWithMonthNames(startDate);

      return `${startFormatted} - ${formatDateWithMonthNames(endDate)}`;
    },
    [formatDay, formatDayMonth, formatDateWithMonthNames]
  );
};
